<template>
  <message-bar v-if="hasPcqmDashboardWarning" :style="pcqmDashboardWarningStyle" type="critical">
    <p v-html="pcqmDashboardWarningText" />
  </message-bar>
</template>

<script>
import MessageBar from '@/components/generic/presentational/molecules/messageBar/MessageBar.vue'
import moment from 'moment'

export default {
  components: { MessageBar },
  props: {
    warningBanner: {
      type: Object,
      default: null,
    },
  },
  computed: {
    pcqmDashboardWarningText() {
      return this.warningBanner?.TextBlock
    },
    pcqmDashboardWarningStyle() {
      return {
        'background-color': this.warningBanner?.BackgroundColor,
      }
    },
    hasPcqmDashboardWarning() {
      let dateNow = moment.utc()
      let dateFrom = moment.utc(this.warningBanner?.DateFrom)
      let dateTo = moment.utc(this.warningBanner?.DateTo)
      return (
        !!this.pcqmDashboardWarningText &&
        (!dateFrom.isValid() || dateNow.isSameOrAfter(dateFrom, 'day')) &&
        (!dateTo.isValid() || dateNow.isSameOrBefore(dateTo, 'day'))
      )
    },
  },
}
</script>
<style lang="scss" scoped></style>
